interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage';
  data?: Record<string, unknown>;
}

const baseSchemas = {
  Organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫画',
    url: 'https://www.hanmanhua.com',
    description: '韩漫画免费阅读平台，提供海量好看的韩国漫画大全，支持下拉式观看，更新及时体验流畅。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  },
  WebSite: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫画',
    url: 'https://www.hanmanhua.com',
    description: '韩漫画免费阅读_看漫画下拉式_好看的韩国漫画大全_韩国漫画网站',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.hanmanhua.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  },
};

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const schema = type === 'WebPage'
    ? { '@context': 'https://schema.org', '@type': 'WebPage', ...data }
    : baseSchemas[type];

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}